import React from 'react'
import { Box, Typography } from '@mui/material'

import Image from '@components/Image'

type ImageProps = {
  data: {
    imgboximage: {
      asset: {
        _ref: string
      }
    }
    image_caption: string
    alt_attribute: string
  }
  imageParams: {
    maxWidth: number
  }
}

export const ImageWithAddons = ({ data, imageParams }: ImageProps) => (
  <Box sx={{ position: 'relative', img: { mt: 3.5, mx: 'auto' } }}>
    <Image
      props={data.imgboximage?.asset?._ref}
      alt={data.alt_attribute}
      maxWidth={imageParams?.maxWidth}
    />

    <Typography
      variant='h3'
      sx={{
        width: '100%',
        fontSize: 24,
        lineHeight: '28px',
        textAlign: 'center',
      }}>
      {data.image_caption}
    </Typography>
  </Box>
)
